import ObjectIdService from "@/utils/ObjectIdUtils";
import { FormApi } from "final-form";
import { Field } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import FormValidators from "../../../components/Form/Validation/FormValidators";
import i18n from "../../../i18n";
import BFInput from "../../abstract-ui/forms/input/BFInput";
import BFButton from "../../abstract-ui/general/Button/BFButton";

export const EmailFormPart = (props: {
  form: FormApi;
  prefix?: string;
  disabled?: boolean;
}) => {
  return (
    <FieldArray name={(props.prefix || "") + "emails"}>
      {({ fields }) => (
        <div className={`section emails-section`}>
          <div className={`section-title __h3 margin-bottom-0 margin-top-0`}>
            {i18n.t("Contact.Form.Sections.Emails", "E-Mail")}
            <BFButton
              disabled={props.disabled}
              className={`margin-left-10`}
              appearance="link"
              size="xs"
              onClick={() =>
                fields.push({
                  id: ObjectIdService.new(),
                  email: "",
                  note: "",
                })
              }
            >
              {i18n.t(
                "Contact.Form.Fields.Email.AddAnother",
                "Weitere E-Mail Adresse hinzufügen"
              )}
            </BFButton>
          </div>
          <div className="emails">
            {fields.map((name, index) => (
              <div className={`email-entry`} key={index}>
                <div className={`field-row`}>
                  <Field
                    name={`${name}.email`}
                    validate={FormValidators.compose(
                      FormValidators.required(),
                      FormValidators.email()
                    )}
                  >
                    {({ input, meta }) => (
                      <div className={`__field __flex-2`}>
                        <BFInput
                          disabled={props.disabled}
                          {...input}
                          // label={`${i18n.t(
                          //   "Contact.Form.Fields.Email.Label",
                          //   "Straße"
                          // )}*`}
                          placeholder={i18n.t(
                            "Contact.Form.Fields.Email.Placeholder",
                            "E-Mail Adresse"
                          )}
                          validation={
                            meta.error && meta.touched
                              ? {
                                  level: "error",
                                  message: meta.error,
                                }
                              : undefined
                          }
                        />
                      </div>
                    )}
                  </Field>
                  <Field
                    name={`${name}.note`}
                    validate={FormValidators.compose(FormValidators.max(150))}
                  >
                    {({ input, meta }) => (
                      <div className={`__field __flex-1`}>
                        <BFInput
                          disabled={props.disabled}
                          {...input}
                          // label={`${i18n.t(
                          //   "Contact.Form.Fields.Email.Label",
                          //   "Straße"
                          // )}*`}
                          prefix={"i"}
                          placeholder={i18n.t(
                            "Contact.Form.Fields.Email.NotePlaceholder",
                            "Notiz"
                          )}
                          validation={
                            meta.error && meta.touched
                              ? {
                                  level: "error",
                                  message: meta.error,
                                }
                              : undefined
                          }
                        />
                      </div>
                    )}
                  </Field>
                  <BFButton
                    style={{ maxHeight: 36 }}
                    disabled={props.disabled}
                    appearance="link"
                    size="xs"
                    onClick={() => {
                      if (fields.length > 1) {
                        fields.remove(index);
                      } else {
                        props.form.mutators.setValue(
                          (props.prefix || "") + "emails",
                          null
                        );
                        props.form.mutators.setValue(
                          (props.prefix || "") + "helpers.showEmails",
                          false
                        );
                      }
                    }}
                  >
                    {i18n.t("Global.Buttons.remove")}
                  </BFButton>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </FieldArray>
  );
};
